import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { AuthService } from "./auth.service";

@Injectable()
export class HttpResponseInceptor implements HttpInterceptor {
    constructor(private authService: AuthService) { }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        return next.handle(request).pipe(   
            map((event: HttpEvent<any>) => {
                if (event instanceof HttpResponse) {
                    // console.log("HTTP Interceptor", event);
                    if (event.status == 200 && event.body != null && event.body["respCode"] == "servererror.1002") {
                        // console.log("Interceptor 1002", event.body["respCode"]);
                        this.authService.logout();
                        // return event;
                    } else {
                        return event;
                    }
                } else {
                    return event;
                }
            })
        );
    }
}